const React = require("react");
const { usePrintify } = require("../context/PrintifyContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;

const SellerPrintifyConnection = () => {
  const { api, t } = usePrintify();
  const resource = useResource(() => api.getConnection(), [api]);
  const [busy, setBusy] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const execute = async (action, success) => {
    setBusy(true); setError(""); setMessage("");
    try { const result = await action(); if (success) setMessage(success); await resource.reload(); return result; }
    catch (requestError) { setError(requestError.message); return null; }
    finally { setBusy(false); }
  };
  const connection = resource.data?.connection;
  const connected = connection?.status === "connected";
  const signupUrl = resource.data?.signupUrl || "https://printify.com/";
  const connect = async () => {
    const result = await execute(() => api.connect({}), "");
    if (result?.authorizationUrl) window.location.assign(result.authorizationUrl);
  };
  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_printify_connection_title", "Printify connection"),
      description: t("h_printify_connection_desc", "Connect through official Printify OAuth. Your Printify tokens stay encrypted on the Elakay server."),
    }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: false, reload: resource.reload, t }, h(React.Fragment, null,
      message ? h("div", { className: "pyds-success" }, message) : null,
      error ? h("div", { className: "pyds-alert", role: "alert" }, error) : null,
      h("div", { className: "pyds-form" },
        h("div", { className: "pyds-row pyds-between" }, h("h3", null, connection?.accountName || "Printify"), h(StatusBadge, { status: connection?.status || "not_connected", t })),
        connection?.accountEmail ? h("p", { className: "pyds-muted" }, connection.accountEmail) : null,
        connected ? h("p", null, `${t("h_printify_store", "Store")}: ${connection.shopName || "—"}`) : null,
        connection?.errorSafeMessage ? h("div", { className: "pyds-alert" }, connection.errorSafeMessage) : null,
        h("div", { className: "pyds-row" },
          !connected ? h(Button, { disabled: busy, onClick: connect }, connection?.status === "connection_error" ? t("h_printify_reconnect", "Reconnect Printify") : t("h_printify_connect", "Connect Printify")) : null,
          connected ? h(Button, { variant: "secondary", disabled: busy, onClick: () => execute(api.testConnection, t("h_printify_test_ok", "Connection test passed.")) }, t("h_printify_test", "Test connection")) : null,
          connected ? h(Button, { disabled: busy, onClick: connect }, t("h_printify_reconnect", "Reconnect Printify")) : null,
          connection ? h(Button, { variant: "danger", disabled: busy, onClick: () => { if (window.confirm(t("h_printify_confirm_disconnect", "Disconnect Printify? Imported products will remain in Elakay."))) execute(api.disconnect, t("h_printify_disconnected", "Printify disconnected.")); } }, t("h_printify_disconnect", "Disconnect")) : null
        ),
        h("hr", null),
        h("h3", null, t("h_printify_create_account", "No Printify account?")),
        h("p", { className: "pyds-muted" }, t("h_printify_create_account_desc", "Create a free Printify account, then return here to connect it.")),
        h("a", { className: "pyds-btn secondary", href: signupUrl, target: "_blank", rel: "noopener noreferrer" }, t("h_printify_create_account_action", "Create Printify Account"))
      )
    ))
  );
};

module.exports = { SellerPrintifyConnection };
